<ng-container
  *ngIf="{
    status: control?.statusChanges | async,
    valid: control?.valid || false,
    touched: touched
  } as state"
>
  <ng-container *ngIf="!state.valid && state.touched">
    <ng-container *ngFor="let error of getErrors()">
      <p class="text-danger">
        {{ getErrorMessage(error) || getServerErrorMessage(error) }}
      </p>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="this.error && state.touched">
    <p class="text-danger mb-3">
      {{ error }}
    </p>
  </ng-container>
</ng-container>
